import projectSettingsConnectRoutes from './project-settings-connect.tsx';

const commonClassicProjectSettingsRoutes = [
	/\/plugins\/servlet\/project-config/i,
	/\/jira\/software\/c\/projects\/.+\/settings\/code/i,
	/\/jira\/software\/c\/projects\/.+\/settings\/deployments/i,
	/\/plugins\/servlet\/project-config\/.+\/administer-components/i,
	/\/plugins\/servlet\/project-config\/.+\/administer-versions/i,
	/\/plugins\/servlet\/project-config\/.+\/fields/i,
	/\/plugins\/servlet\/project-config\/.+\/issuesecurity/i,
	/\/plugins\/servlet\/project-config\/.+\/issuetypes/i,
	/\/plugins\/servlet\/project-config\/.+\/notifications/i,
	/\/plugins\/servlet\/project-config\/.+\/permissions/i,
	/\/plugins\/servlet\/project-config\/.+\/screens/i,
	/\/plugins\/servlet\/project-config\/.+\/workflows/i,
	/\/project\/DeleteProject!default\.jspa/i,
	/\/secure\/project\/EditProject!default\.jspa/i,
	// Collectors
	/\/secure\/AddCollector/i,
	/\/secure\/InsertCollectorHelp/i,
	/\/ViewCollector!default\.jspa\?projectKey=/i,
	/\/ViewCollectors!default\.jspa\?projectKey=/i,
	// Development tools
	/\/secure\/ConfigureDevStatus.jspa\?projectKey=/i,
	// Hipchat
	/\/InstallHipChat\.jspa\?projectKey=/i,
	/\/secure\/ConfigureHipChat\.jspa\?projectKey=(.+)/i,
	// Forge
	/\/jira\/software\/c\/projects\/.+\/settings\/apps\/([a-z0-9-]+)\/([a-z0-9-]+)(\/*)?/i,
];

const projectSettingsRoutes = [
	...commonClassicProjectSettingsRoutes,
	/\/plugins\/servlet\/project-config\/.+\/issuelayout/i,
	...projectSettingsConnectRoutes,
	// Service Desk project settings
	/\/servicedesk\/admin\/(\w+)/i,
	// SPA settings
	/\/projects\/\w+\/settings(\/\w+)*/i,
];

export default projectSettingsRoutes;
